import { combineReducers } from "redux";

import LayoutReducer from "./layouts/reducer";

import LoginReducer from "./auth/login/reducer";

import ProfileReducer from "./auth/profile/reducer";


const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    Profile: ProfileReducer,
});


export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;